<template>
  <div class="container my-4">
    <div class="heading" role="alert">
      <h4><i class="bi bi-qr-code-scan-fill"></i> QR Scan</h4>
    </div>
    <div class="bg-light p-4 rounded shadow-sm">
      <!-- Display error or decoded string -->
      <p v-if="error" class="text-danger">{{ error }}</p>
      <p v-if="decodeString" class="text-success">{{ decodeString }}</p>

      <!-- Flashlight toggle button -->
      <div class="text-center mb-3 torch-button">
        <button 
          class="btn btn-primary" 
          @click="toggleTorch">
          <i :class="torch ? 'bi bi-lightbulb-fill' : 'bi bi-lightbulb'"></i> 
          {{ torch ? 'TURN OFF FLASHLIGHT' : 'TURN ON FLASHLIGHT' }}
        </button>
      </div>

      <!-- QR code stream component -->
      <qrcode-stream 
        v-bind:key="qrStreamKey" 
        @init="onInit" 
        @decode="onDecode" 
        :torch="torch"></qrcode-stream>

      <!-- Optional: Display loading indicator -->
      <div v-if="loading" class="text-center mt-3">
        <span>Loading...</span>
      </div>
    </div>

<!-- Modal for QR Scan result -->
<!-- <div v-if="showModal" class="modal-overlay" role="dialog" aria-modal="true">
<QrScanModel/>
</div> -->
<!-- Modal for QR Scan result -->
<div v-if="showModal" class="modal-overlay" role="dialog" aria-modal="true">
<!-- <QrScanModel :qrData="decodeString" :student="student" :studentItem="studentItem" :studentCode="studentCode" @close="closeModal"/> -->
 <!-- Show bootstrap spinner when fetching data -->
        <div v-if="modalLoading" class="d-flex flex-column align-items-center justify-content-center" style="height: 150px;">
          <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mt-2">Loading...</div>
        </div>

        <!-- Show the scan model after loading -->
        <QRScanModel
          v-else
          :qrData="decodeString"
          :student="student"
          :studentItem="studentItem"
          :studentCode="studentCode"
          @close="closeModal"
        />

</div>


  </div>
</template>

<script>
import axios from 'axios';
import { QrcodeStream } from 'vue3-qrcode-reader';
import QRScanModel from '@/components/TeacherDashboard/QRScan/QRScanModel.vue'

export default {
  data() {
    return {
      token: "",
      id: "",
      error: '',
      decodeString: '',
      torch: false,
      loading: false, // Added loading state
      showModal: false, // Controls modal visibility
      qrStreamKey: 0, // Unique key to force re-render of the QR code stream
      student: null, // Initialize studentData
      studentCode: null,
      studentItem: [], // Ensure studentItem is an array
      attendanceStatus: 'Present', // Default status
      remark: '',
      modalLoading: false,  // modal data fetching loading state
    };
  },
  components: {
    QrcodeStream,
    QRScanModel
  },
  methods: {
    async onInit(promise) {
      this.loading = true; // Show loading indicator

      try {
        await promise; // Await the promise but don't need to use the result
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "User denied camera access permission";
        } else if (error.name === 'NotFoundError') {
          this.error = "No suitable camera device installed";
        } else if (error.name === 'NotSupportedError') {
          this.error = "Page is not served over HTTPS (or localhost)";
        } else if (error.name === 'NotReadableError') {
          this.error = "Maybe camera is already in use";
        } else if (error.name === 'OverconstrainedError') {
          this.error = "Did you request the front camera although there is none?";
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "Browser seems to be lacking features";
        }
      } finally {
        this.loading = false; // Hide loading indicator
      }
    },

    onDecode(decodeString) {
      this.decodeString = decodeString;
      this.fetchStudentData();
      this.showModal = true; // Show modal after decoding
    },

    toggleTorch() {
      this.torch = !this.torch;
    },

    closeModal() {
      this.showModal = false; // Hide modal when closed
      this.resetQRCodeStream(); // Reset QR code reader for next scan
    },

    resetQRCodeStream() {
      // Change the key of the QR code stream component to force it to re-render
      this.qrStreamKey++;
    },
    async fetchStudentData() {
// this.loading = true;
this.modalLoading = true;
try {
  const response = await axios.post('/qrStudentDetailsTeacher', {
    qr_code: this.decodeString,
    user_id: this.id, // Ensure this key matches what the backend expects
    teacher_id: this.teacher_id,
  }, {
    headers: { Authorization: `Bearer ${this.token}` },
  });

  // Correctly assign response data
  this.student = response.data.student || null;
  this.studentCode = response.data.student_code || null;
  this.studentItem = response.data.student_item || null;

} catch (error) {
  this.error = error.response ? error.response.data.error : 'An unexpected error occurred';
} finally {
  // this.loading = false;
  this.modalLoading = false;
}
},

getDisplayedAmount(item) {
    const amount = parseFloat(item.amount);
    if (item.selectedOption === "half") {
      return (amount / 2).toFixed(2);
    } else if (item.selectedOption === "quarter") {
      return (amount / 4).toFixed(2);
    }
    return amount.toFixed(2);
  }


  },
  mounted() {
this.token = localStorage.getItem("token");
this.id = localStorage.getItem("id");
this.teacher_id = localStorage.getItem("teacher_id");

if (!this.token || !this.id) {
  this.error = "Required information is missing. Please log in again.";
}

this.studentItem.forEach(item => {
    this.$set(item, 'selectedOption', 'full'); // Default to Full Payment
  });
}

}
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding-top: 2.5vh !important;
  height: 100%;
}

.heading{
    background-color: rgb(95, 95, 241);
    border: 2px solid #007bff;
    border-radius: 5px;
    padding: 0.5%;
    color: white;
    margin-bottom: 2dvh;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.btn {
  display: flex;
  align-items: center;
}

.btn i {
  margin-right: 8px;
}

.modal-body {
max-height: 80vh;
overflow-y: auto;
}


.classMain {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.leftClass, .rightClass {
  flex: 1;
  min-width: 280px;
  max-width: 48%;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.border {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
}

.rounded {
  border-radius: 10px;
}

.form-label {
  font-weight: bold;
}

@media (max-width: 576px) {
  .container {
    padding: 0 15px;
  }

  .torch-button {
    display: block; /* Show button on small screens */
  }
}

@media (min-width: 577px) {
  .torch-button {
    display: none; /* Hide button on larger screens */
  }
}

.text-center {
  text-align: center;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.btn-close:hover {
  color: red;
}
</style>
